import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Building2 } from "lucide-react";
import { getImageUrl } from "@/lib/api";

const PLACEHOLDER_PARTNERS = [
  { name: "Kementerian Sosial RI", category: "Pemerintah" },
  { name: "Kemenko PMK", category: "Pemerintah" },
  { name: "PT Pertamina", category: "BUMN" },
  { name: "PT Telkom Indonesia", category: "BUMN" },
  { name: "Universitas Padjadjaran", category: "Akademisi" },
  { name: "ITB", category: "Akademisi" },
  { name: "UNICEF Indonesia", category: "Internasional" },
  { name: "World Vision", category: "Internasional" },
];

export default function Partners() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/partners").then((r) => setItems(r.data.items || [])).catch(() => {});
  }, []);

  const partners = items.length > 0 ? items : PLACEHOLDER_PARTNERS;
  const doubled = [...partners, ...partners];

  return (
    <section className="section-y bg-white border-y border-slate-200/70" data-testid="home-partners">
      <div className="container-sf">
        <div className="text-center mb-10">
          <div className="eyebrow">Kemitraan Strategis</div>
          <h3 className="text-2xl md:text-3xl font-bold text-slate-900 mt-3">
            Berkolaborasi lintas sektor untuk dampak yang lebih luas
          </h3>
        </div>

        <div className="relative overflow-hidden mask-fade">
          <div className="marquee-track gap-4">
            {doubled.map((p, i) => (
              <div
                key={i}
                className="shrink-0 w-64 rounded-2xl border border-slate-200 bg-white px-6 py-5 flex items-center gap-3"
                data-testid={`partner-${i}`}
              >
                {p.logo_url ? (
                  <img src={getImageUrl(p.logo_url)} alt={p.name} className="h-10 w-10 object-contain" />
                ) : (
                  <div className="h-10 w-10 rounded-lg bg-[var(--brand-soft-blue)] flex items-center justify-center">
                    <Building2 className="h-5 w-5 text-[var(--brand-blue)]" />
                  </div>
                )}
                <div>
                  <div className="text-sm font-semibold text-slate-900 leading-tight">{p.name}</div>
                  <div className="text-[11px] text-slate-500 uppercase tracking-wider mt-0.5">{p.category}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <style>{`.mask-fade { -webkit-mask-image: linear-gradient(to right, transparent, black 8%, black 92%, transparent); mask-image: linear-gradient(to right, transparent, black 8%, black 92%, transparent); }`}</style>
    </section>
  );
}
